export const MAX_LIMIT = 100000;
export const MIN_LIMIT = 1;
export const MIN_CONFERENCE_LIMIT = 0;

// Per-currency price for one unit of an extra item. All 4 currencies stay
// populated even when values are identical — locks the shape so a future
// per-currency tweak is a one-line edit, not a refactor.
export interface ExtraCostMatrix {
  chf: number;
  eur: number;
  usd: number;
  gbp: number;
}

export type ExtraCostItem = 'user' | 'store' | 'group_appointment' | 'conference';

export type BrandExtraCosts = Record<ExtraCostItem, ExtraCostMatrix>;

// Values mirror the v2 add-on prices in the Stripe catalogue (verified
// against Calenso AG TEST/LIVE + JRNI Business TEST/LIVE on 2026-05-15).
// Every add-on is 5/mo · 60/yr flat across CHF/EUR/USD/GBP in both brands.
// If Stripe pricing diverges in future, edit the matching cell only — the
// shape (per-brand × per-currency) is already in place.
const CALENSO_EXTRA_COSTS: BrandExtraCosts = {
  user:              { chf: 5, eur: 5, usd: 5, gbp: 5 },
  store:             { chf: 5, eur: 5, usd: 5, gbp: 5 },
  group_appointment: { chf: 5, eur: 5, usd: 5, gbp: 5 },
  conference:        { chf: 5, eur: 5, usd: 5, gbp: 5 },
};

const JRNI_BUSINESS_EXTRA_COSTS: BrandExtraCosts = {
  user:              { chf: 5, eur: 5, usd: 5, gbp: 5 },
  store:             { chf: 5, eur: 5, usd: 5, gbp: 5 },
  group_appointment: { chf: 5, eur: 5, usd: 5, gbp: 5 },
  conference:        { chf: 5, eur: 5, usd: 5, gbp: 5 },
};

const EXTRA_COSTS_BY_BRAND: Record<string, BrandExtraCosts> = {
  Calenso:          CALENSO_EXTRA_COSTS,
  'JRNI Business':  JRNI_BUSINESS_EXTRA_COSTS,
};

/**
 * Resolves the extra-item unit cost for the active brand + currency.
 * Falls back to Calenso pricing if the brand isn't mapped.
 */
export function getExtraCost(item: ExtraCostItem, currency: string, brand: string): number {
  const brandCosts = EXTRA_COSTS_BY_BRAND[brand] ?? CALENSO_EXTRA_COSTS;
  const key = currency.toLowerCase() as keyof ExtraCostMatrix;
  return brandCosts[item][key];
}

export const SALES_TOKEN = '82e80dc8-9318-4be5-9be1-e8ef79859fca';
